import RefreshTokenUseCase from './use-cases/RefreshToken';
import ResetPasswordUseCase from './use-cases/ResetPassword';
import ChangePasswordUseCase from './use-cases/ChangePassword';
import AbstractModuleFactory from '@core/shared/module-factory';
import AccountActivationUseCase from './use-cases/AccountActivation';
import RequestResetPasswordUseCase from './use-cases/RequestResetPassword';
import RequestAccountActivationUseCase from './use-cases/RequestAccountActivation';
import GetRecaptchaSiteKeyUseCase, { AbstractGetRecaptchaSiteKeyUseCase } from './use-cases/GetRecaptchaSiteKey';
import { IResetPasswordUseCase, IChangePasswordUseCase, IAccountActivationUseCase, IRequestResetPasswordUseCase, IRequestAccountActivationUseCase } from './interfaces';
import UserSessionRespositoryFactory, { IUserSessionRespository } from '@infrastructure/persistance/user-session';

export class AuthModuleFactory extends AbstractModuleFactory {
  /**
   * Use case that get recaptch sitekey
   */
  createGetRecaptchaSiteKeyUseCase(): AbstractGetRecaptchaSiteKeyUseCase {
    return this.ensureInstance('GetRecaptchaSiteKeyUseCase', () => new GetRecaptchaSiteKeyUseCase());
  }

  /**
   * Use case for changing password of a user
   */
  createChangePasswordUseCase(): IChangePasswordUseCase {
    return this.ensureInstanceWithoutErrorHandler('ChangePasswordUseCase', () => new ChangePasswordUseCase());
  }

  /**
   * Use case for start an account activation
   */
  createRequestAccountActivationUseCase(): IRequestAccountActivationUseCase {
    return this.ensureInstance('RequestAccountActivationUseCase', () => new RequestAccountActivationUseCase());
  }

  /**
   * Use case for complete account actionvation
   */
  createAccountActivationUseCase(): IAccountActivationUseCase {
    return this.ensureInstance('AccountActivationUseCase', () => new AccountActivationUseCase());
  }

  /**
   *  Use this use case if you want to start the process for change the password.
   */
  createRequestResetPasswordUseCase(): IRequestResetPasswordUseCase {
    return this.ensureInstance('RequestResetPasswordUseCase', () => new RequestResetPasswordUseCase());
  }

  /**
   *  Use this use case if you want to reset the password.
   */
  createResetPasswordUseCase(): IResetPasswordUseCase {
    return this.ensureInstance('ResetPasswordUseCase', () => new ResetPasswordUseCase());
  }

  createRefreshTokenUseCase(): RefreshTokenUseCase {
    const sessionRepo: IUserSessionRespository = UserSessionRespositoryFactory.createLocalUserSessionRepository();
    return this.ensureInstance('RefreshTokenUseCase', () => new RefreshTokenUseCase(sessionRepo));
  }

  static new(): AuthModuleFactory {
    return new AuthModuleFactory();
  }
}

export default AuthModuleFactory.new();
